import BaseService from './baseService';

class UtangPiutang extends BaseService {
	async getUtangPiutang(type, opts = {}) {
		this.endPoint = `/get-utang-or-piutang?type=${type}`;
		return this.get(opts);
	}
}

export default new UtangPiutang();
